import { render, staticRenderFns } from "./VideoRoomHeader.vue?vue&type=template&id=696efa1a&scoped=true&"
import script from "./VideoRoomHeader.vue?vue&type=script&lang=js&"
export * from "./VideoRoomHeader.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomHeader.vue?vue&type=style&index=0&id=696efa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696efa1a",
  null
  
)

/* custom blocks */
import block0 from "./VideoRoomHeader.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoRoomHeader.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports